import {
  PaginatedResponse,
  ProductType,
  Scheme,
  SchemeMaster,
  SchemeType,
} from "../types";
import { api } from "./axios";

interface SchemeListResponse<T extends SchemeType> {
  count: number;
  next: string | null;
  previous: string | null;
  results: Scheme<T>[];
}

export type SchemeApiOptions = {
  page?: string;
  page_size?: string;
  type: SchemeType;
  frequency?: string;
  ids?: number[];
  search?: string;
  isin?: string;
  product_type?: ProductType;
  amc_id?: number;
};

const PAGE_SIZE = 50;

export const getSchemeList = <T extends SchemeType>(
  options: SchemeApiOptions
): Promise<SchemeListResponse<T>> => {
  const {
    page,
    type = "",
    ids,
    frequency,
    page_size,
    search,
    isin,
    amc_id,
    product_type,
  } = options;

  const params = {
    ids,
    page,
    page_size: page_size || PAGE_SIZE,
    frequency,
    search,
    isin,
    amc_id,
    product_type,
  };

  switch (type) {
    case "sip":
      return api.get(`metadata/sip-schemes/`, {
        params,
      });
    case "stp":
      return api.get(`metadata/stp-schemes/`, {
        params,
      });
    case "swp":
      return api.get(`metadata/swp-schemes/`, {
        params,
      });
    default:
      return api.get(`onetime-schemes/`, {
        params,
      });
  }
};

export const getScheme = <T extends SchemeType>(
  options: Pick<SchemeApiOptions, "type"> & { id: number }
): Promise<Scheme<T>> => {
  const { type = "", id } = options;
  switch (type) {
    case "sip":
      return api.get(`metadata/sip-schemes/${id}/`);
    case "stp":
      return api.get(`metadata/stp-schemes/${id}/`);
    case "swp":
      return api.get(`metadata/swp-schemes/${id}/`);
    default:
      return api.get(`onetime-schemes/${id}/`);
  }
};

interface SchemeMasterParams {
  page?: number;
  pageSize?: number;
  isin?: string;
  search?: string;
}

export function getSchemeMasterList(
  params: SchemeMasterParams
): Promise<PaginatedResponse<SchemeMaster>> {
  return api.get("schemes/", {
    params: {
      page: params.page,
      page_size: params.pageSize,
      isin: params.isin,
      search: params.search,
    },
  });
}

export function getSchemeMaster(id: number): Promise<SchemeMaster> {
  return api.get(`schemes/${id}/`);
}
